"use client";

import { useState } from "react";
import { TfiMenu} from "react-icons/tfi";
import { IoClose } from "react-icons/io5";
import Menu from "@/components/Menu";
import Social from "@/components/Social";

function MobileMenu() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className="flex items-center gap-3 text-2xl">
      <div 
        className="w-8 h-8 relative cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
        style={{ minWidth: '32px' }}
      >
        <div
          className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
            isOpen ? "opacity-0 scale-75 rotate-45" : "opacity-100 scale-100 rotate-0"
          }`}
        >
          <TfiMenu />
        </div>

        <div
          className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
            isOpen ? "opacity-100 scale-100 rotate-0" : "opacity-0 scale-75 -rotate-45"
          }`}
        >
          <IoClose style={{ width: '32px', height: '32px' }} />
        </div>
      </div>

      <div
        className={`absolute top-15 left-0 w-full px-8 py-8 -z-1000 bg-white dark:bg-black transition-all duration-300 ${
          isOpen ? "h-auto z-1000 opacity-100" : "h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="flex flex-col gap-4 items-center h-full">
          <Menu
            orientation="vertical"
            size="large"
            align="center"
            onClick={() => setIsOpen(false)}
          />
          <Social className="mt-2" />
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;